import {
  IApiEpBillingProductFeatureSubscription,
  IApiEpBillingProductPostsPackage,
} from "@smp/api";
import {
  UiCardActionArea,
  UiCardActions,
  UiCardContent,
  UiCardUncustomized,
  UiTypography,
} from "@smp/ui";
import { textCurrencySymbolGet } from "@smp/utils";
import clsx from "clsx";
import { useCallback, useMemo } from "react";

import { useStyles } from "./ui_product.css";

export const UiProduct = ({
  fullWidth,
  name,
  onClick,
  product,
  ...props
}: {
  fullWidth?: boolean;
  name: React.ReactNode;
  onClick: (
    product:
      | IApiEpBillingProductFeatureSubscription
      | IApiEpBillingProductPostsPackage,
  ) => void;
  product:
    | IApiEpBillingProductFeatureSubscription
    | IApiEpBillingProductPostsPackage;
}) => {
  const classes = useStyles();

  const amount =
    product.type === "feature-subscription"
      ? product.period_days || 1
      : product.amount;

  const amountFormatted = useMemo(() => {
    const formatter = new Intl.NumberFormat(undefined, {
      style: "decimal",
      useGrouping: true,
    });
    return formatter.format(amount);
  }, [amount]);

  const priceFormatted = useMemo(() => {
    const formatter = new Intl.NumberFormat(undefined, {
      style: "decimal",
      useGrouping: true,
    });
    return formatter.format(product.price);
  }, [product.price]);

  const handleClick = useCallback(() => {
    onClick(product);
  }, [onClick, product]);

  return useMemo(
    () => (
      <UiCardUncustomized
        className={clsx(classes.card, {
          [classes.fullWidth]: fullWidth,
        })}
      >
        <UiCardActionArea onClick={handleClick} {...props}>
          <UiCardContent>
            <UiTypography variant="h3">{amountFormatted}</UiTypography>
            <UiTypography>{name}</UiTypography>
          </UiCardContent>
          <UiCardActions className={classes.cardActions}>
            <UiTypography align="right">
              {priceFormatted} {textCurrencySymbolGet(product.currency)}
            </UiTypography>
          </UiCardActions>
        </UiCardActionArea>
      </UiCardUncustomized>
    ),
    [
      amountFormatted,
      classes.card,
      classes.cardActions,
      classes.fullWidth,
      fullWidth,
      handleClick,
      name,
      product.currency,
      props,
      priceFormatted,
    ],
  );
};
